import React from 'react';
import _get from 'lodash/get';

import ContentBlock from '../../components/ContentBlock';
import HocAuthenticate from '../../components/HocAuthenticate';
import Layout from '../../components/Layout';
import LpPhysicalCards from '../../components/LinkPoints/LpPhysicalCards';
import PageContent from '../../components/PageContent';
import PageTitle from '../../components/PageTitle';
import CheckPageAccess from '../../components/Theme/CheckPageAccess';
import AccountContainer from '../../containers/Account';
import { fetcherApiRoute } from '../../services/api/fetcher';

const PagePhysicalCardsChild = () => {
  const [records, setRecords] = React.useState([]);

  // Calling the protected API route /api/lp-physical-cards
  // should be in a child component of <Layout />
  // so that it only makes the call after user is authenticated from HocAuthenticate.
  // This is because <Layout /> will not render it's children if user is not authenticated.
  // This way we can prevent race condition of calling the protected API route before user is authenticated.
  const handleGetPhysicalCards = () => {
    fetcherApiRoute('/api/lp-physical-cards', {
      method: 'GET',
    })
      .then((res) => {
        setRecords(_get(res, 'cards', []));
      })
      .catch(() => {
        setRecords([]);
      });
  };

  React.useEffect(() => {
    handleGetPhysicalCards();
  }, []);

  return (
    <ContentBlock>
      <PageTitle testId="physicalCards">View cards</PageTitle>
      <PageContent>
        <LpPhysicalCards records={records} handleGetPhysicalCards={handleGetPhysicalCards} />
      </PageContent>
    </ContentBlock>
  );
};

const PagePhysicalCards = (props) => {
  const { fetchUserProfile, userData, authLoading } = props;

  return (
    <AccountContainer
      user={userData}
      loading={authLoading} // global loading state
      refreshUserData={fetchUserProfile}
    >
      <CheckPageAccess userRole="linkplus" />
      <Layout>
        <PagePhysicalCardsChild />
      </Layout>
    </AccountContainer>
  );
};

export default HocAuthenticate(PagePhysicalCards);
